import { WrapperListTypeProps } from './TypeProps';
import { Active } from '../ActiveWarranty';
import IconService from '@app/assets/img/icon-service.svg';
import IconActive from '@public/next/gimg/warranty/active-service.svg';
import classNames from 'classnames';

import styles from './WrapperList.module.scss';

export const WrapperList = ({ className, children, title, text, status, logo, active, onClick, service }: WrapperListTypeProps) => {
  const availabilityService = service != null;
  return (
    <div data-title={title} className={classNames(styles.Wrapper, className)}>
      <div className={styles.Content} onClick={onClick}>
        <div className={styles.Text}>
          {logo && <IconService width={24} height={24} />}
          {availabilityService && <div>{!service ? 'Шиномонтаж' : 'Автосервис '}</div>}
          <div className={classNames(styles.Active, { [styles.ActiveService]: availabilityService })}>
            {active && <IconActive width={24} height={24} />}
            {text}
          </div>
          {status && <Active text={status} />}
        </div>
        {children}
      </div>
    </div>
  );
};
